import PropTypes from 'prop-types';
import { FC } from 'react';
import brandLogoFull from '../assets/logos/ast-logo-full.webp';
import brandLogoMark from '../assets/logos/ast-logo-mark.webp';
import brandLogoMarkLight from '../assets/logos/ast-logo-mark-light.webp';

interface ILogoProps {
	width?: number;
	height?: number;
	brandImage?: boolean;
	variant?: 'full' | 'mark' | 'markLight';
	className?: string;
}
const Logo: FC<ILogoProps> = ({ width, height, variant = 'full', className }) => {
	const logo =
		variant === 'markLight'
			? brandLogoMarkLight
			: variant === 'mark'
			? brandLogoMark
			: brandLogoFull;

	return (
		<img
			src={logo}
			alt={`${process.env.REACT_APP_PROJECT_NAME}`}
			height={height}
			width={width}
			className={className}
		/>
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	brandImage: PropTypes.bool,
	variant: PropTypes.oneOf(['full', 'mark', 'markLight']),
	className: PropTypes.string,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
	brandImage: false,
	variant: 'full',
	className: undefined,
};

export default Logo;
